import React, {FC} from "react";
import {useAppDispatch} from "../../../redux/redux.hook";
import {IconButton} from "@material-ui/core";
import {Autorenew} from "@material-ui/icons";
import {listClientsThunk} from "../redux/clients.thunk";

export const ClientsReloadButton: FC = () => {
    const dispatch = useAppDispatch();

    const reload = () => dispatch(listClientsThunk());

    return (
        <div style={{display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center'}}>
            <IconButton onClick={e => {
                e.stopPropagation();
                reload();
            }}>
                <Autorenew/>
            </IconButton>
        </div>
    );
}